// Firebase v9+ modular SDK
import { initializeApp } from 'firebase/app';
import { getAuth, RecaptchaVerifier } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage, ref } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyCtaFRZfPJkeplddW8X31lhbqECF8zGRik",
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "shopie-bazar-e4920.firebaseapp.com",
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "shopie-bazar-e4920",
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "shopie-bazar-e4920.appspot.com",
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "839810219479",
    appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:839810219479:web:021bcd69c50c692beb5f92",
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-C4P73B2KJV"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const firebaseAuth = getAuth(app);

// Configure Auth settings for better reCAPTCHA support
firebaseAuth.settings = {
    appVerificationDisabledForTesting: false
};

// Initialize Cloud Firestore and get a reference to the service
export const firestore = getFirestore(app);

// Initialize Firebase Storage
export const storage = getStorage(app);

// Initialize Firebase Analytics
export const analytics = getAnalytics(app);

// Initialize Firebase Functions with asia-south1 region
export const functions = getFunctions(app, 'asia-south1');

// Connect to Functions emulator in development (if needed)
// Uncomment the lines below if you want to use local emulator
/*
if (process.env.NODE_ENV === 'development') {
  try {
    connectFunctionsEmulator(functions, 'localhost', 5001);
  } catch (e) {
    console.log('Functions emulator not connected:', e.message);
  }
}
*/

export default app;